import { Button, Chip, Stack } from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import { autoSizeColumns } from "global/util/gridUtils/autoSizeColumns";
import Row from "page/Automatensuche/interface/RowTypes";
import { useRef, useState } from "react";
import DepositMachineDataService from "service/data-service/automate-controller/DepositMachineData.service";
import ExportService from "service/report-service/export/Export.service";
import DataGrid from "../DataGrid/DataGrid";
import FilterController from "../FilterSystem/controller/FilterController";
import FilterInput from "../FilterSystem/FilterInput";
import { DepositMachineContainer } from "./container/DepositMachineContainer";
import "./depositMachineList.scss";

interface props {
  onCellClicked(data: Row): any;
}

const DepositMachineList = (props: props) => {
  const [machineData, setMachineData] = useState<Array<Row>>([]);
  const [resetFilters, setResetFilters] = useState<boolean>(false);

  const dataGridRef = useRef<AgGridReact>(null);

  function getDepositMachineList() {
    DepositMachineDataService.retrieveDepositMachineData(
      FilterController.getFilterObject(),
      retrieveMachineList,
      callbackOnFail
    );
  }

  function retrieveMachineList(data: Array<Row>) {
    setMachineData(data);

    DepositMachineContainer.splice(0);

    data.forEach((row) => {
      DepositMachineContainer.push(row);
    });
  }

  function callbackOnFail(error: any) {
    console.log(error);
  }

  const columnsNotToResize = [
    "region",
    "regionName",
    "rnsOrt",
    "automatModellName",
  ];

  function handleOnRowDataChanged() {
    setTimeout(
      () =>
        machineData.length === 0
          ? dataGridRef.current!.api.sizeColumnsToFit()
          : autoSizeColumns(dataGridRef, columnsNotToResize),
      200
    );
  }

  function handleOnGridReady() {
    setMachineData([...DepositMachineContainer]);
  }

  return (
    <Stack rowGap={0.5}>
      <FilterInput
        resetFilters={resetFilters}
        onEnterKey={getDepositMachineList}
      />
      <Stack className="rowStack buttonStack" justifyContent="space-between">
        <Stack className="rowStack filterButtons">
          <Button
            variant="secondary"
            onClick={() => {
              setResetFilters(resetFilters ? false : true);
              FilterController.resetFilterCache();
            }}
          >
            Filter zurücksetzen
          </Button>
          <Button variant="contained" onClick={getDepositMachineList}>
            Filter anwenden
          </Button>
        </Stack>
        <Stack className="rowStack">
          <Chip
            className="exportChip"
            size="small"
            variant="outlined"
            label={"EXCEL Export"}
            clickable
            onClick={() => {
              ExportService.downloadSearchResult(
                FilterController.getFilterObject()
              );
            }}
          />
        </Stack>
      </Stack>

      <DataGrid
        dataGridRef={dataGridRef}
        dataToShow={machineData}
        onCellClicked={props.onCellClicked}
        onGridReady={handleOnGridReady}
        onRowDataChanged={() => {
          handleOnRowDataChanged();
        }}
      />
    </Stack>
  );
};

export default DepositMachineList;
